export var parseGeneratedCodeFormat = function (format) {
    var elements = [];
    if (!format)
        return elements;
    var part = '';
    var inBlock = false;
    for (var i = 0; i < format.length; i++) {
        var c = format[i];
        if (!inBlock && c === '[') {
            inBlock = true;
            if (part !== '') {
                elements.push({ id: 'Text', t: part });
                part = '';
            }
        }
        else if (inBlock && c === ']') {
            inBlock = false;
            part = part.toLowerCase();
            var n = parseInt(part.replace('counter:n', '').trim());
            if (Number.isInteger(n)) {
                elements.push({ id: 'Counter', n: n });
            }
            part = '';
        }
        else {
            part += c;
        }
    }
    if (part !== '') {
        elements.push({ id: 'Text', t: part });
    }
    return elements;
};
var randomCounter = Math.round(Math.random() * 500);
export var generateGeneratedCodeExample = function (input, counter) {
    if (!input)
        return null;
    var elements = [];
    if (typeof input === 'string')
        elements = parseGeneratedCodeFormat(input);
    else if (Array.isArray(input))
        elements = input;
    else
        return null;
    var exampleCounter = (counter && parseInt(String(counter))) || randomCounter;
    return elements.reduce(function (result, el) {
        if (el.id === 'Text')
            return result + (el.t || '');
        if (el.id === 'Counter')
            return result + String(exampleCounter).padStart(el.n || 0, '0');
        return result;
    }, '');
};
